import React from "react";
import { SchedulerUnit } from "@sonder/ui/source/styled/layouts/SchedulerLayout";
import { GetTaskSchedulesPlace } from "core/queries/GetTaskSchedules";
import { titlelizeCase } from "core/utils/titlelizeCase";
import { getSpaceCleanInternalRef } from "schedule/utils/scheduleUtils";

interface PlaceListItemProps {
  place: GetTaskSchedulesPlace;
}

export const PlaceListItem = ({ place }: PlaceListItemProps) => {
  return (
    <SchedulerUnit>
      {titlelizeCase(
        place.cufSpaceType
          ? getSpaceCleanInternalRef(place)
          : place.aptNumber || place.shortInternalRef || "",
      )}
    </SchedulerUnit>
  );
};
